import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import Button from "../../../ui/Button/Button";
import { useGameContext } from "../../../game/GameContext/GameContext";
import DemoModeLabel from "./BetButton.demo";
import { BetButtonWrapper, StyledButton, StyledTooltip } from "./BetButton.styled";
import { getFloat } from "../../../helpers/formatNumber";
var BetButton = function (_a) {
    var text = _a.text, disabled = _a.disabled;
    var _b = useGameContext(), inProgress = _b.inProgress, autoPlayInProgress = _b.autoPlayInProgress, betAmount = _b.betAmount, balance = _b.balance, handleBetButton = _b.handleBetButton, betButtonShake = _b.betButtonShake, getBetButtonTooltip = _b.getBetButtonTooltip;
    var betButtonDisabled = useMemo(function () {
        if (disabled)
            return true;
        if (autoPlayInProgress && !inProgress)
            return false;
        if (parseFloat(getFloat(balance / 10000)) >= betAmount && betAmount >= 0)
            return false;
        return true;
    }, [balance, betAmount, autoPlayInProgress, inProgress, disabled]);
    var betButtonTooltip = getBetButtonTooltip();
    if (inProgress && !autoPlayInProgress) {
        return null;
    }
    return (_jsxs(BetButtonWrapper, { "data-tooltip-id": "bet-button-tooltip", children: [_jsx(StyledButton, { className: betButtonShake ? 'shake' : '', children: _jsx(Button, { variant: "action", fullWidth: true, disabled: betButtonDisabled, onClick: handleBetButton, children: text }) }), _jsx(DemoModeLabel, { enabled: betAmount === 0 }), _jsx(StyledTooltip, { id: "bet-button-tooltip", content: betButtonTooltip || '', isOpen: !!betButtonTooltip, place: "top", opacity: 1 })] }));
};
BetButton.displayName = "BetButton";
export default BetButton;
//# sourceMappingURL=BetButton.js.map